import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import PayForm from './components/PayForm';
import useScript from './hooks/useScript';

function App() {
  useScript('https://securepay.tinkoff.ru/html/payForm/js/tinkoff_v2.js')
  return (
    <div className="App">
      <Container className="d-flex  justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}>
        <div className='w-100' style={{ maxWidth: '400px' }}>
          <h1 className='text-center mt-3'>Carrenza оплата аренды</h1>
          <PayForm />
          <a className='text-muted' href='https://carrenza.ru'>На основной сайт</a>
          <p className='mt-3 text-small'>Made with <span>💖</span> by <a className='text-muted' href='https://github.com/frankieksai'>Frankie ksai</a></p>
        </div>
      </Container>
    </div>
  );
}

export default App;
